import { Button, colors, Heading, HFlow, Icon, Modal, ModalBody, ModalFooter, VFlow } from 'bold-ui'
import React from 'react'

interface ExcluirAprazamentoModalProps {
  modalOpen: boolean
  handleModalClose(): void
}

export const ExcluirAprazamentoModal = (props: ExcluirAprazamentoModalProps) => {
  const { modalOpen } = props

  return (
    <Modal open={modalOpen} onClose={props.handleModalClose} manageOverflow={false} size='auto'>
      <ModalBody>
        <VFlow vSpacing={2}>
          <Heading level={1}>
            <HFlow alignItems='center' hSpacing={1}>
              <Icon color={colors.orange.c40} icon='exclamationTriangleOutline' size={3.0} />
              Deseja excluir o registro de aprazamento?
            </HFlow>
          </Heading>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button>Cancelar</Button>
          <Button kind='danger'>Excluir</Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
